<!--
// app/components/Shared/icons/ShirtIcon.vue
-->
<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
};

withDefaults(defineProps<Props>(), {
  height: 14,
  width: 14,
});
</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_761_11857)">
      <path
        d="M4.23089 7.75025L1 4.37512L3.77511 1.47613C4.06677 1.17136 4.46236 1.00009 4.87489 1H5.66667C5.68873 1.63106 5.94422 2.22859 6.37939 2.66689C6.81457 3.10519 7.3955 3.35011 8 3.35011C8.6045 3.35011 9.18543 3.10519 9.62061 2.66689C10.0558 2.22859 10.3113 1.63106 10.3333 1H11.1236C11.5361 1.00009 11.9317 1.17136 12.2233 1.47613L15 4.37512L11.7691 7.75025M4.23089 7.75025V12.8755C4.23089 13.0232 4.25873 13.1694 4.31283 13.3058C4.36692 13.4423 4.44621 13.5662 4.54617 13.6706C4.64613 13.7751 4.7648 13.8579 4.8954 13.9144C5.026 13.9709 5.16597 14 5.30733 14H10.6927C10.9782 14 11.252 13.8815 11.4538 13.6706C11.6557 13.4598 11.7691 13.1737 11.7691 12.8755V7.75025M4.23089 7.75025V5.49963M11.7691 7.75025V5.49963"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<style scoped></style>
